"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shallowEqualForeignProps = exports.shallowEqual = void 0;
var _shallowequal = _interopRequireDefault(require("shallowequal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var shallowEqual = exports.shallowEqual = function shallowEqual(objA, objB) {
  return (0, _shallowequal["default"])(objA, objB);
};
var shallowEqualForeignProps = exports.shallowEqualForeignProps = function shallowEqualForeignProps(objA, objB, nativeProps) {
  var foreignComparator = function foreignComparator(a, b, c) {
    if (!c) {
      return;
    }
    return !nativeProps[a] && shallowEqual(a, b);
  };
  return (0, _shallowequal["default"])(objA, objB, foreignComparator);
};